var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',{style:({ margin: '0 10px' })},[_vm._v("Fee Details")]),_c('OwnerFees',{attrs:{"fees":_vm.fees}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }